import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import ManuscriptCenter from './components/ManuscriptCenter';
import NotesCenter from './components/NotesCenter';
import { CorkboardsListPage, CorkboardEditorPage } from '../../../../features/corkboards';
import { TimelinesListPage, TimelineEditorPage } from '../../../../features/timelines';
import CharactersEditorPage from '../../../../features/characters/CharactersEditorPage';
import { GameDesignPage } from '../../../../features/gamedesign';

const CenterContent = ({
  activeProject = null,
  chapters,
  activeSection = 'manuscript',
  notesView = 'dashboard',
  corkboardId = null,
  timelineId = null,
  showTitlePage = false,
  rightSidebarOpen = true,
  onChapterClick = null,
  onSceneAdded,
  onAddScene,
  suppressSceneLoading = false,
  onNoteSelect = null,
  gameTool = 'erd',
  onGameToolChange = null,
}) => {
  // Handle corkboards routes
  if (activeSection === 'corkboards') {
    if (corkboardId) {
      return (
        <Box sx={{ height: '100%', overflow: 'hidden' }}>
          <CorkboardEditorPage corkboardId={corkboardId} />
        </Box>
      );
    }
    return (
      <Box sx={{ height: '100%', overflow: 'hidden' }}>
        <CorkboardsListPage />
      </Box>
    );
  }

  // Handle timelines routes
  if (activeSection === 'timelines') {
    if (timelineId) {
      return (
        <Box sx={{ height: '100%', overflow: 'hidden' }}>
          <TimelineEditorPage timelineId={timelineId} />
        </Box>
      );
    }
    return (
      <Box sx={{ height: '100%', overflow: 'hidden' }}>
        <TimelinesListPage />
      </Box>
    );
  }

  if (activeSection === 'notes') {
    return (
      <Box sx={{ height: '100%', overflow: 'hidden' }}>
        <NotesCenter notesView={notesView} onNoteSelect={onNoteSelect} />
      </Box>
    );
  }

  if (activeSection === 'characters') {
    return (
      <Box sx={{ height: '100%', overflow: 'hidden' }}>
        <CharactersEditorPage />
      </Box>
    );
  }

  if (activeSection === 'gamedesign') {
    return (
      <Box sx={{ height: '100%', overflow: 'hidden' }}>
        <GameDesignPage
          projectId={activeProject?._id || ''}
          tool={gameTool}
          onToolChange={onGameToolChange}
        />
      </Box>
    );
  }

  return (
    <ManuscriptCenter
      activeProject={activeProject}
      chapters={chapters}
      showTitlePage={showTitlePage}
      rightSidebarOpen={rightSidebarOpen}
      onChapterClick={onChapterClick}
      onSceneAdded={onSceneAdded}
      onAddScene={onAddScene}
      suppressSceneLoading={suppressSceneLoading}
    />
  );
};

export default CenterContent;

/* eslint-disable react/require-default-props */
CenterContent.propTypes = {
  activeProject: PropTypes.shape({
    _id: PropTypes.string,
    title: PropTypes.string,
    pseudonym: PropTypes.string,
    type: PropTypes.string,
    createdAt: PropTypes.string,
    updatedAt: PropTypes.string,
    thinOwner: PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
    }),
  }),
  chapters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      wordCount: PropTypes.number,
    })
  ).isRequired,
  showTitlePage: PropTypes.bool,
  rightSidebarOpen: PropTypes.bool,
  onChapterClick: PropTypes.func,
  onSceneAdded: PropTypes.func,
  onAddScene: PropTypes.func,
  suppressSceneLoading: PropTypes.bool,
  activeSection: PropTypes.string,
  notesView: PropTypes.string,
  corkboardId: PropTypes.string,
  timelineId: PropTypes.string,
  onNoteSelect: PropTypes.func,
  gameTool: PropTypes.string,
  onGameToolChange: PropTypes.func,
};
/* eslint-enable react/require-default-props */
